<template src="./template.html"></template>

<script>
export default {
  name: "GalleryList",
  data() {
    return {
      gallery_data: []
    }
  },
  methods: {
    async GetGalleryData() {
      let result = await this.SendGetData(process.env.VUE_APP_BASE_API + 'gallery/get_gallery_list.php')
      if (result != "error") {
        console.log()
        this.gallery_data = JSON.parse(result.data)
      }
    }
  },
  created() {
    this.GetGalleryData()
  }
}
</script>